export default "__VITE_ASSET__g$bBgu3q__"